




import Vue from "vue";
import ThemeEditor from "@/components/organisms/ThemeEditor.vue";

export default Vue.extend({
  components: { ThemeEditor },
  props: ["novelId"],
  methods: {},
  created() {},
});
